<!-- ── Main Dialog (select_type + pickup_datetime) ── -->
@if (currentStep() === 'select_type' || currentStep() === 'pickup_datetime') {
  <p-dialog
    [visible]="true"
    [modal]="true"
    [style]="{ width: '869px', maxWidth: '95vw', margin: '1rem' }"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [appendTo]="'body'"
    [showHeader]="false"
    styleClass="amenities-main-dialog"
  >
    <div class="pl-[45px] pr-[31px] pt-[36px] pb-[70px] relative max-h-[85vh] overflow-y-auto overflow-x-hidden max-md:pb-5">

      <!-- Header -->
      <div class="flex items-start mb-[10px] gap-2">
        <button type="button" (click)="onBack()"
          class="bg-transparent cursor-pointer flex items-center justify-center p-1 rounded-[6px] flex-shrink-0 w-8 h-8 mt-0.5 transition-colors hover:bg-slate-100 border-0">
          <img src="assets/icons/backward-arrow.svg" alt="Back" class="w-8 h-8" />
        </button>
        <h2 class="text-[28px] font-bold text-[#192A3E] flex-1 text-left leading-tight break-words">
          @if (currentStep() === 'select_type') { Please Select Type }
          @else if (currentStep() === 'pickup_datetime') { Select Date &amp; Time }
        </h2>
        <button type="button" (click)="onClose()"
          class="bg-transparent cursor-pointer flex items-center justify-center p-1 rounded-[6px] flex-shrink-0 w-10 h-10 mt-0.5 transition-colors hover:bg-slate-100 border-0">
          <img src="assets/icons/dialog-cancel.svg" alt="close" class="w-10 h-10" />
        </button>
      </div>

      <!-- ════════════════════════════════════════════════════ -->
      <!-- Step 1: Select Entry Type                            -->
      <!-- ════════════════════════════════════════════════════ -->
      @if (currentStep() === 'select_type') {
        <div class="mt-[10px]">
          <p class="text-[20px] font-bold text-[#192A3E] mb-[14px] max-[480px]:text-base">Guest Entry</p>
          <div class="grid grid-cols-2 gap-[14px] max-[560px]:grid-cols-1 max-[560px]:gap-[10px]">
            @for (type of entryTypes; track type.value) {
              <button type="button"
                class="group flex items-center px-[16px] py-[20px] w-full h-[95px] rounded-[10px] border-[1.5px] bg-white border-[#EBEFF2] cursor-pointer transition-[border-color,background] duration-150 text-left gap-[14px] hover:bg-[#2E7FBE] hover:border-[#2E7FBE] data-[active=true]:bg-[#2E7FBE] data-[active=true]:border-[#2E7FBE]"
                [attr.data-active]="selectedEntryType()?.value === type.value ? true : null"
                (click)="selectEntryType(type)">
                <div class="w-[55px] h-[55px] min-w-[55px] rounded-[5px] flex items-center justify-center bg-[#F2F6F8] flex-shrink-0 overflow-hidden">
                  <img [src]="type.icon" [alt]="type.label" class="w-full h-full object-cover" />
                </div>
                <div class="flex-1 flex flex-col gap-[3px] min-w-0">
                  <div class="text-[18px] font-semibold text-[#192A3E] leading-tight group-hover:text-white group-data-[active=true]:text-white">{{ type.label }}</div>
                  <div class="text-[13px] text-[#4E4D4D] group-hover:text-white group-data-[active=true]:text-white leading-[1.4] line-clamp-2">{{ type.description }}</div>
                </div>
              </button>
            }
          </div>
        </div>
      }

      <!-- ════════════════════════════════════════════════════ -->
      <!-- Step 3: Date & Time                                  -->
      <!-- ════════════════════════════════════════════════════ -->
      @if (currentStep() === 'pickup_datetime') {
        <div class="mt-[70px] mb-[80px] min-[640px]:mt-[114px] min-[640px]:mb-[80px]">
          <div class="flex gap-5 justify-center max-[639px]:flex-col max-[639px]:gap-[26px]">

            <!-- Date -->
            <div class="flex items-center gap-3 min-[640px]:w-[338px] relative">
              <div class="flex-1 border-2 border-[#D9DDE0] rounded-[5px] h-[63px] flex items-center justify-between bg-white pl-[38px]">
                <span class="text-base min-[640px]:text-[20px] text-[#232F40] font-semibold">
                  {{ getFormattedDate() }} &bull; {{ getDayOfWeek() }}
                </span>
                <button type="button" (click)="openDatePicker(dateInput)"
                  class="text-[#238EC6] border-2 border-[#D9DDE0] absolute right-0 bg-[#E8EDF0] w-[53px] flex items-center justify-center h-[63px] rounded-tr-[5px] rounded-br-[5px]">
                  <img src="assets/icons/calendar_3.svg" alt="calendar" class="w-[34px] h-[34px]" />
                </button>
                <input #dateInput type="date" [value]="selectedDate()"
                  class="absolute opacity-0 pointer-events-none w-0 h-0" (change)="onDateChange($event)" />
              </div>
            </div>

            <div class="flex items-center gap-[18px] min-[640px]:gap-3">
              <!-- Hour Dropdown -->
              <div class="time-dropdown-wrap border-2 w-1/2 border-[#D9DDE0] rounded-[5px] px-2 min-[414px]:px-4 py-3 h-[63px] flex items-center bg-white min-[640px]:min-w-[188px] relative cursor-pointer"
                (click)="toggleHourDropdown($event)">
                <img src="assets/icons/clock-icon.svg" alt="time" class="w-5 h-5 min-[414px]:w-[34px] min-[414px]:h-[34px] flex-shrink-0 mr-[10px]" />
                <span class="text-base min-[414px]:text-[20px] text-[#232f40] font-semibold">{{ getHourLabel() }}</span>
                @if (showHourDropdown()) {
                  <div class="time-dropdown fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[160px] h-[571px] max-h-[85vh] z-[100001] bg-white border-2 border-[#D9DDE0] rounded-[5px] shadow-[0_10px_40px_rgba(0,0,0,0.25)] flex flex-col overflow-y-auto"
                    (click)="$event.stopPropagation()">
                    @for (hour of hoursList; track $index) {
                      <div class="w-full text-center py-[18px] text-[20px] font-semibold text-[#232F40] cursor-pointer transition-colors hover:bg-[#F2F6F8]"
                        [class.bg-\[\#F2F6F8\]]="selectedHour() === hour.value"
                        (click)="selectHour($index); $event.stopPropagation()">
                        {{ hour.title }}
                      </div>
                    }
                  </div>
                }
              </div>

              <!-- Minute Dropdown -->
              <div class="time-dropdown-wrap border-2 w-1/2 border-[#D9DDE0] rounded-[5px] px-2 min-[414px]:px-4 py-3 h-[63px] flex items-center bg-white min-[640px]:min-w-[143px] relative cursor-pointer"
                (click)="toggleMinuteDropdown($event)">
                <img src="assets/icons/clock-icon.svg" alt="duration" class="w-5 h-5 min-[414px]:w-[34px] min-[414px]:h-[34px] flex-shrink-0 mr-[10px]" />
                <span class="text-base min-[414px]:text-[20px] text-[#232f40] font-semibold">:{{ selectedMinute() }}</span>
                @if (showMinuteDropdown()) {
                  <div class="time-dropdown fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[160px] h-[571px] max-h-[85vh] z-[100001] bg-white border-2 border-[#D9DDE0] rounded-[5px] shadow-[0_10px_40px_rgba(0,0,0,0.25)] flex flex-col overflow-y-auto"
                    (click)="$event.stopPropagation()">
                    @for (min of minutesList; track $index) {
                      <div class="w-full text-center py-[18px] text-[20px] font-semibold text-[#232F40] cursor-pointer transition-colors hover:bg-[#F2F6F8]"
                        [class.bg-\[\#F2F6F8\]]="selectedMinute() === min"
                        (click)="selectMinute($index); $event.stopPropagation()">
                        :{{ min }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- Next button -->
          <div class="flex justify-end w-full absolute bottom-0 right-0 py-5 pr-[34px] min-[640px]:pr-10 bg-white border-t border-[#EBEFF2] rounded-bl-[10px] rounded-br-[10px]">
            <button type="button" (click)="onDateTimeNext()"
              class="text-white w-[117px] py-1 rounded-[5px] bg-[#238EC6] text-[16px] font-semibold hover:bg-[#238EC6]/80 transition">
              Next
            </button>
          </div>
        </div>
      }

    </div>
  </p-dialog>
}

<!-- ── Step 2: Select Contacts ── -->
@if (currentStep() === 'select_contacts') {
  <pa-contact-list-popup
    [addedContactList]="selectedGuests()"
    [addedUsers]="selectedGuests()"
    [showSkipButton]="true"
    [showAddGuestButton]="true"
    addedListLabel="Add Guests"
    (closeContactListPopup)="onGuestListPopupClose($event)"
    (addGuestClicked)="onAddGuestClicked()"
  />
}

<!-- ── Add Contact Popup ── -->
@if (isAddContactPopupOpen()) {
  <pa-add-contact-popup
    (closeAddContactPopup)="onAddContactPopupClose()"
  />
}

<!-- ── Step 4: Review Details ── -->
@if (currentStep() === 'review_details') {
  <p-dialog
    [visible]="true"
    [modal]="true"
    [style]="{ width: '532px', maxWidth: '95vw', margin: '1rem' }"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [appendTo]="'body'"
    styleClass="amenities-review-dialog"
  >
    <ng-template #header>
      <div class="w-full flex items-center gap-2 mb-3">
        <button type="button" (click)="onBack()"
          class="bg-transparent cursor-pointer flex items-center justify-center p-1 rounded-[6px] flex-shrink-0 w-8 h-8 mt-0.5 transition-colors hover:bg-slate-100 border-0">
          <img src="assets/icons/backward-arrow.svg" alt="Back" class="w-8 h-8" />
        </button>
        <h2 class="text-[28px] font-bold text-[#192A3E] flex-1 text-left leading-tight">Review Details</h2>
        <button type="button" (click)="onClose()"
          class="bg-transparent cursor-pointer flex items-center justify-center p-1 rounded-[6px] flex-shrink-0 w-10 h-10 mt-0.5 transition-colors hover:bg-slate-100 border-0">
          <img src="assets/icons/dialog-cancel.svg" alt="close" class="w-10 h-10" />
        </button>
      </div>
    </ng-template>

    <div class="flex flex-col gap-3">

      <!-- User + entry type row -->
      <div class="flex items-center gap-[10px]">
        <div class="relative w-[50px] h-[50px] rounded-full overflow-hidden flex-shrink-0">
          <img [src]="getUserAvatar()" alt="avatar"
            [class.blur-sm]="isPictureBlocked(currentUser?.profile_picture_moderation_status)"
            class="w-full h-full object-cover" />
          @if (isPictureBlocked(currentUser?.profile_picture_moderation_status)) {
          <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-5 h-5 pointer-events-none" />
          }
        </div>
        <p class="text-[20px] text-[#2F3A48] flex-1 m-0">
          <strong>{{ getUserFullName() }}</strong> add
          <strong>{{ selectedEntryType()?.label }}</strong>
          <button type="button" (click)="currentStep.set('select_type')" aria-label="Edit entry type"
            class="bg-transparent border-0 cursor-pointer p-[2px_4px] inline-flex items-center align-middle ml-0.5">
            <img src="assets/icons/pencil.svg" alt="edit" />
          </button>
        </p>
      </div>

      <!-- Chips row -->
      <div class="flex items-center gap-2 flex-wrap">

        <!-- Entry type chip -->
        <button type="button"
          class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full bg-[#192A3E] text-white border border-[#192A3E] hover:opacity-90 transition"
          (click)="currentStep.set('select_type')">
          {{ selectedEntryType()?.label }}
          <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5 brightness-0 invert" />
        </button>

        <!-- Management chip -->
        <button type="button"
          class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full hover:opacity-90 transition border"
          [style.background-color]="selectedManagement() ? '#192A3E' : '#fff'"
          [style.color]="selectedManagement() ? '#fff' : '#192A3E'"
          [style.border-color]="selectedManagement() ? '#192A3E' : '#D9DDE2'"
          (click)="openAssignPopup('management', 'Assign Management')">
          <div class="relative w-6 h-6 rounded-full bg-[#2E7FBE] flex-shrink-0 flex items-center justify-center overflow-hidden"
            [style.opacity]="!selectedManagement() ? '0.5' : '1'">
            @if (getAssigneeAvatar(selectedManagement()); as avatar) {
              <img [src]="avatar" alt=""
                [class.blur-sm]="isPictureBlocked(selectedManagement()?.profile_picture_moderation_status)"
                class="w-full h-full object-cover" />
              @if (isPictureBlocked(selectedManagement()?.profile_picture_moderation_status)) {
              <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-3 h-3 pointer-events-none" />
              }
            } @else {
              <img src="assets/images/dummy-avatar.jpg" alt="" class="w-full h-full object-cover" />
            }
          </div>
          {{ selectedManagement() ? getContactDisplayName(selectedManagement()) : 'Assign Management' }}
          <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5"
            [class.brightness-0]="selectedManagement()" [class.invert]="selectedManagement()" />
        </button>

        <!-- Front Desk chip -->
        <button type="button"
          class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full hover:opacity-90 transition border"
          [style.background-color]="selectedFrontDesk() ? '#192A3E' : '#fff'"
          [style.color]="selectedFrontDesk() ? '#fff' : '#192A3E'"
          [style.border-color]="selectedFrontDesk() ? '#192A3E' : '#D9DDE2'"
          (click)="openAssignPopup('front_desk', 'Assign Front Desk')">
          <div class="relative w-6 h-6 rounded-full bg-[#2E7FBE] flex-shrink-0 flex items-center justify-center overflow-hidden"
            [style.opacity]="!selectedFrontDesk() ? '0.5' : '1'">
            @if (getAssigneeAvatar(selectedFrontDesk()); as avatar) {
              <img [src]="avatar" alt=""
                [class.blur-sm]="isPictureBlocked(selectedFrontDesk()?.profile_picture_moderation_status)"
                class="w-full h-full object-cover" />
              @if (isPictureBlocked(selectedFrontDesk()?.profile_picture_moderation_status)) {
              <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-3 h-3 pointer-events-none" />
              }
            } @else {
              <img src="assets/images/dummy-avatar.jpg" alt="" class="w-full h-full object-cover" />
            }
          </div>
          {{ selectedFrontDesk() ? getContactDisplayName(selectedFrontDesk()) : 'Assign Front Desk' }}
          <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5"
            [class.brightness-0]="selectedFrontDesk()" [class.invert]="selectedFrontDesk()" />
        </button>
      </div>

      <!-- Date pill -->
      <button type="button"
        class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full bg-[#192A3E] text-white border border-[#192A3E] hover:opacity-90 transition self-start"
        (click)="goToDateTimeFromReview()">
        <img src="assets/icons/calendar_2.png" alt="cal" class="w-[18px] h-[18px] brightness-0 invert flex-shrink-0" />
        <span>Set on: {{ getPickupDateTimeLabel() }}</span>
        <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5 brightness-0 invert flex-shrink-0" />
      </button>

      <!-- Location pill -->
      <button type="button"
        class="flex items-center gap-2 text-sm font-semibold px-3 py-[5px] rounded-full bg-[#192A3E] text-white border border-[#192A3E] hover:opacity-90 transition self-start"
        (click)="openLocationDialog()">
        <img src="assets/icons/location-pin.svg" alt="location" class="w-[18px] h-[18px] brightness-0 invert flex-shrink-0" />
        <span class="line-clamp-1 text-left">Location at: {{ locationAddress() || getUserAddress() || 'No address on file' }}</span>
        <img src="assets/icons/dropdown-arrow.svg" alt="arrow" class="w-2.5 h-2.5 brightness-0 invert flex-shrink-0" />
      </button>

      <hr class="my-2" />

      <!-- Guest Entry Details card -->
      <div class="bg-white border border-[#EBEFF2] rounded-[10px] p-4 mb-[55px]">
        <div class="flex items-center justify-between mb-3">
          <span class="text-[22px] font-semibold text-[#192A3E]">Guest Entry Details</span>
          <button type="button" (click)="openGuestSelector()" class="p-1">
            <img src="assets/icons/dialog-cancel.svg" alt="edit" class="w-[22px] h-[22px] rotate-45" />
          </button>
        </div>
        <div class="border-t border-[#E4E6E8] mb-3"></div>

        @if (selectedGuests().length === 0) {
          <p class="text-[13px] text-[#90A0B7]">No guests selected.</p>
        } @else {
          <ul class="flex flex-col gap-[25px]">
            @for (guest of selectedGuests(); track $index) {
              <li class="flex items-center gap-3">
                <div class="relative w-[55px] h-[55px] rounded-full flex-shrink-0 flex items-center justify-center overflow-hidden bg-[#2E7FBE]">
                  @if (guest.profile_picture) {
                    <img [src]="guest.profile_picture" alt=""
                      [class.blur-sm]="isPictureBlocked(guest.profile_picture_moderation_status)"
                      class="w-full h-full object-cover" />
                    @if (isPictureBlocked(guest.profile_picture_moderation_status)) {
                    <img src="assets/icons/eye-icon-white.png" alt="Under review" class="absolute inset-0 m-auto w-5 h-5 pointer-events-none" />
                    }
                  } @else {
                    <span class="text-white text-xs font-bold">{{ getContactInitials(guest) }}</span>
                  }
                </div>
                <span class="flex-1 text-[16px] font-semibold text-[#192A3E]">{{ getContactDisplayName(guest) }}</span>
                <button type="button"
                  class="bg-transparent border-0 cursor-pointer p-1    flex-shrink-0"
                  (click)="removeGuest($index)">
                  <img src="assets/icons/clear.svg" alt="remove" class="w-[24px] h-[24px]" />
                </button>
              </li>
            }
          </ul>
        }

       
      </div>

      <!-- Footer -->
      <div class="bg-white border-t-[1.5px] border-[#EBEFF2] flex justify-end -mx-6 -mb-6 px-6 py-[14px] rounded-b-[10px]">
        <button type="button" (click)="onCreateRequest()" [disabled]="isSubmitting()"
          class="flex items-center gap-2 px-[17px] py-[6px] bg-[#238EC6] text-white text-base font-semibold border-0 rounded-[5px] cursor-pointer transition-colors hover:bg-[#1d7aad] disabled:opacity-60 disabled:cursor-not-allowed max-[480px]:w-full max-[480px]:justify-center">
          {{ isSubmitting() ? 'Creating...' : 'Create Request' }}
        </button>
      </div>

    </div>
  </p-dialog>
}

<!-- ── Assign Popup ── -->
@if (showAssignPopup()) {
  <pa-assign-sp-popup
    [title]="assignPopupTitle()"
    [assignType]="assignPopupType()"
    (close)="onAssignSelected($event)"
  />
}

<!-- ── Location Dialog ── -->
@if (showLocationDialog()) {
  <p-dialog
    [visible]="true"
    [modal]="true"
    [style]="{ width: isMobileView() ? '90%' : '869px', maxWidth: '95vw', margin: '1rem' }"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [appendTo]="'body'"
    styleClass="amenities-location-dialog"
  >
    <ng-template #header>
      <div class="w-full flex items-center gap-3">
        <button type="button" (click)="dismissLocationDialog()"
          class="bg-transparent border-0 cursor-pointer flex items-center justify-center p-1 rounded-[6px] w-8 h-8 hover:bg-slate-100 transition-colors flex-shrink-0">
          <img src="assets/icons/backward-arrow.svg" alt="Back" class="w-8 h-8" />
        </button>
        <h2 class="text-[28px] font-bold text-[#192A3E] flex-1">Enter Locations</h2>
        <button type="button" (click)="dismissLocationDialog(); onClose()"
          class="bg-transparent border-0 cursor-pointer flex items-center justify-center p-1 rounded-[6px] w-10 h-10 hover:bg-slate-100 transition-colors flex-shrink-0">
          <img src="assets/icons/dialog-cancel.svg" alt="close" class="w-10 h-10" />
        </button>
      </div>
    </ng-template>

    <div class="grid gap-[14px] mt-2"
      [style]="isMobileView() ? 'grid-template-columns:1fr;height:auto;' : 'grid-template-columns:320px 1fr;height:420px;'">

      <!-- Left Panel -->
      <div class="flex flex-col gap-[10px] overflow-hidden"
        [style]="isMobileView() ? '' : 'height:100%;'">
        <div class="bg-white border-[1.5px] border-[#EBEFF2] rounded-lg px-4 py-3 flex-shrink-0">
          <p class="text-[14px] font-semibold text-[#4E4D4D] mb-[6px] tracking-[0.04em]">Pickup Location</p>
          <div class="flex items-center gap-2">
            <input type="text" placeholder="Enter Pickup Location"
              [value]="addressInput()"
              (input)="onAddressInput($any($event.target).value)"
              (keyup.enter)="onAddressSearch()"
              class="flex-1 border-none outline-none text-lg text-[#192A3E] bg-transparent font-semibold placeholder:text-[#192A3E] placeholder:font-semibold" />
            <button type="button"
              class="bg-transparent border-none cursor-pointer flex items-center p-[2px] flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity"
              (click)="onAddressSearch()">
              <img src="assets/icons/pencil.svg" alt="search" class="w-4 h-4" />
            </button>
          </div>
        </div>

        @if (autocompleteResults().length > 0) {
          <div class="flex-1 overflow-y-auto bg-white border-[1.5px] border-[#EBEFF2] rounded-lg flex flex-col min-h-0">
            <p class="text-[20px] font-bold text-[#192A3E] tracking-[0.05em] px-[14px] pt-3 pb-0 flex-shrink-0">Select Address</p>
            @for (prediction of autocompleteResults(); track prediction.place_id) {
              <button type="button"
                class="block w-full text-left px-[14px] py-[10px] text-[16px] text-[#192A3E] bg-transparent border-none border-b border-[#f8fafc] last:border-b-0 cursor-pointer transition-colors hover:bg-[#f0f7fc] hover:text-[#238EC6] leading-[1.4]"
                (click)="onSelectAutocomplete(prediction)">
                {{ prediction.description }}
              </button>
            }
          </div>
        } @else if (savedAddresses().length) {
          <div class="flex-1 overflow-y-auto bg-white border-[1.5px] border-[#EBEFF2] rounded-lg flex flex-col min-h-0">
            <p class="text-[20px] font-bold text-[#192A3E] tracking-[0.05em] px-[14px] pt-3 pb-0 flex-shrink-0">Saved Addresses</p>
            @for (addr of savedAddresses(); track $index) {
              <button type="button"
                class="block w-full text-left px-[14px] py-[10px] text-[16px] text-[#192A3E] bg-transparent border-none border-b border-[#f8fafc] last:border-b-0 cursor-pointer transition-colors hover:bg-[#f0f7fc] hover:text-[#238EC6] leading-[1.4]"
                (click)="selectSavedAddress(addr.label)">
                {{ addr.label }}
              </button>
            }
          </div>
        }
      </div>

      <!-- Map -->
      <div class="rounded-[10px] overflow-hidden border-[1.5px] border-[#EBEFF2] relative"
        [style]="isMobileView() ? 'height:220px;' : 'height:100%;'">
        <div #locationMapEl class="w-full h-full block"></div>
      </div>
    </div>

    <ng-template #footer>
      <div class="flex justify-end gap-3">
        <button type="button"
          class="px-6 h-[32px] text-[#192A3E] font-semibold rounded-lg hover:bg-gray-100 transition border-0 bg-transparent cursor-pointer"
          (click)="dismissLocationDialog()">
          Dismiss
        </button>
        <button type="button"
          class="px-6 h-[32px] text-white rounded-lg bg-[#238EC6] hover:bg-[#238EC6]/80 transition border-0 cursor-pointer font-semibold"
          (click)="onLocationDialogNext()">
          Next
        </button>
      </div>
    </ng-template>
  </p-dialog>
}

<!-- ── Success Popup ── -->
@if (showSuccessPopup()) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/40 z-[11000]">
    <div class="w-[482px] max-w-[95vw] border border-[#192A3E26] rounded-[16px] bg-white shadow-[0_18px_45px_rgba(0,0,0,0.15)] p-[50px_50px_70px_55px] flex flex-col text-left">
      <h2 class="text-[#192A3E] font-bold text-[32px] leading-8">Guest Entry Created!</h2>
      <div class="flex flex-col gap-6 border-t border-[#ebeff2] pt-[35px] mt-[44px] mb-10">
        <p class="text-[#4E4D4D] text-lg leading-6">Your guest entry request has been successfully created.</p>
        <p class="text-[#4E4D4D] text-lg leading-6">Please check your notifications for the latest updates and changes.</p>
        <p class="text-[#4E4D4D] text-lg leading-6">Thank you!</p>
      </div>
      <button type="button" class="text-[#192A3E] text-2xl leading-7 cursor-pointer font-medium" (click)="onSuccessOk()">
        OK
      </button>
    </div>
  </div>
}
